import api from '@/api/api.js'

export default {

    getSexes() {
        const promise = api.clinique().get('/sexes')
        return promise.then((response) => response.data)
    },
    getPatient(id) {
        const promise = api.clinique().get('/patients/' + id)
        return promise.then(response => response.data)
    },

    getPatients() {
        const promise = api.clinique().get('/patients/all/with_validite')
        return promise.then(response => response.data)
    },

    getListeAllPatient(with_consultation) {
        const promise = api.clinique().get('/patients?with_consultation='+with_consultation)
        return promise.then(response => response.data)
    },

    getPatientName(id) {
        const promise = api.clinique().get('/patients-name/' + id)
        return promise.then(response => response.data)
    },
    createPatient(data) {
        const promise = api.clinique().post('/patients/save', data)
        return promise.then(response => response.data)
    },

    checkIfPatientEstAssure(patient_id) {
        const promise = api.clinique().get('/assurances/patient/'+patient_id+'/est_assure')
        return promise.then(response => response.data)
    },

    getPatientInfoAssurance(data) {
        const promise = api.clinique().get('/assurances/patient/'+data.patient_id+'/info_assurance')
        return promise.then(response => response.data)
    },

    getSituationsMatrimoniales() {
        const promise = api.clinique().get('/situations-matrimoniales')
        return promise.then(response => response.data)
    },

    getListeCivilite() {
        const promise = api.clinique().get('/civilites')
        return promise.then(response => response.data)
    },

    getInfoPatient(patient_id) {
        const promise = api.clinique().get('/patients/'+patient_id+'/info')
        return promise.then((response) => response.data)
    },

    savePatient(data) {
        const promise = api.clinique().post('/patients/save', data)
        return promise.then((response) => response.data)
    },

    getPatientInsuranceInfo(patient_id) {
        const promise = api.clinique().get('/patients/'+patient_id+'/insurance-info')
        return promise.then((response) => response.data)
    },

    getStatsDMP(data) {
        const promise = api.clinique().post('/dmp/statistiques', data)
        return promise.then(response => response.data)
    },
}